import { categories } from '@/mocks/comics';

const navCols = [
  {
    title: '站内导航',
    links: [
      { label: '热门推荐', href: '#featured' },
      { label: '人气排行榜', href: '#rankings' },
      { label: '每日更新', href: '#updates' },
      { label: '完结作品', href: '#completed' },
    ],
  },
  {
    title: '题材分类',
    links: categories.slice(0, 5).map((c) => ({ label: c.name, href: '#categories' })),
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '#faq' },
      { label: '关于我们', href: '#about' },
      { label: '订阅周刊', href: '#subscribe' },
      { label: '回到顶部', href: '#home' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-8 py-12 md:py-16">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2.5" aria-label="漫阅韩漫">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-xl w-5 h-5 flex items-center justify-center" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl text-background-50">漫阅韩漫</span>
                <span className="text-xs text-background-400 mt-0.5 tracking-widest">HANREAD</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              高清韩国漫画在线阅读平台，恋爱、奇幻、校园、悬疑等题材分类齐全，完结作品随时可看。
              排行榜帮你锁定人气佳作，按口味选漫不踩雷。
            </p>
            <div className="mt-5 flex gap-2.5">
              {['ri-wechat-line', 'ri-qq-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#about"
                  aria-label={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors"
                >
                  <i className={`${icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </a>
              ))}
            </div>
          </div>

          {navCols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-semibold text-background-50 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-background-300 hover:text-primary-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-background-400">
          <p>© 2026 漫阅韩漫 HanRead · 高清韩国漫画在线阅读平台</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
            contact@hanread.cn
          </p>
        </div>
      </div>
    </footer>
  );
}